export const ROLES = {
  PARTICIPANTE: 'PARTICIPANTE',
  AUTOR: 'AUTOR',
  EVALUADOR: 'EVALUADOR',
  ORGANIZADOR_CIENTIFICO: 'ORGANIZADOR_CIENTIFICO',
  ADMINISTRADOR: 'ADMINISTRADOR',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

export const ROLE_LABELS: Record<Role, string> = {
  [ROLES.PARTICIPANTE]: 'Participante',
  [ROLES.AUTOR]: 'Autor',
  [ROLES.EVALUADOR]: 'Evaluador',
  [ROLES.ORGANIZADOR_CIENTIFICO]: 'Organizador Científico',
  [ROLES.ADMINISTRADOR]: 'Administrador',
};

export function getRoleLabel(rol: string): string {
  return ROLE_LABELS[rol as Role] || rol;
}

export function hasAnyRole(userRoles: string[], requiredRoles: string[]): boolean {
  if (!requiredRoles || requiredRoles.length === 0) return false;
  if (!userRoles || userRoles.length === 0) return false;
  return requiredRoles.some(role => userRoles.includes(role));
}
